import { render, staticRenderFns } from "./SystemSettingsManagement.vue?vue&type=template&id=5e2460e3&"
import script from "./SystemSettingsManagement.vue?vue&type=script&lang=js&"
export * from "./SystemSettingsManagement.vue?vue&type=script&lang=js&"
import style0 from "./SystemSettingsManagement.vue?vue&type=style&index=0&id=5e2460e3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports